import { render, staticRenderFns } from "./AHead.vue?vue&type=template&id=4147954a&scoped=true&"
import script from "./AHead.vue?vue&type=script&lang=js&"
export * from "./AHead.vue?vue&type=script&lang=js&"
import style0 from "./AHead.vue?vue&type=style&index=0&id=4147954a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4147954a",
  null
  
)

export default component.exports